/**
 * Página de produto: fotos extras, abas e link do WhatsApp.
 * Não carrega biblioteca. O módulo roda uma vez e delega os eventos.
 */
if (!window.__oiProduct) {
  window.__oiProduct = true;

  const phoneDigits = (value) => (value || '').replace(/\D/g, '');

  const syncWhatsapp = () => {
    document.querySelectorAll('[data-oi-whatsapp]').forEach((link) => {
      const phone = phoneDigits(link.dataset.phone);
      if (!phone) return;
      const picker = document.querySelector('variant-picker[data-template-product-match="true"]');
      const options = [];
      picker?.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
        const name = input.dataset.optionName;
        if (name && name !== 'Title' && input.value) options.push(`${name}: ${input.value}`);
      });
      const product = link.dataset.productTitle || '';
      let text = `Olá! Quero tirar dúvidas sobre ${product}.`;
      if (options.length) text += ` ${options.join(', ').replace(/\.$/, '')}.`;
      link.href = `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
    });
  };

  document.addEventListener('click', (event) => {
    const more = event.target.closest('[data-oi-gallery-more]');
    if (more) {
      const gallery = more.closest('media-gallery');
      gallery?.setAttribute('data-oi-gallery-open', 'true');
      more.hidden = true;
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.closest('variant-picker')) syncWhatsapp();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncWhatsapp, { once: true });
  } else {
    syncWhatsapp();
  }
}
